import { useEffect } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import type { IncomingLeadQueryOffer } from '@/types/lead-query';
import { stopRinging } from '@/components/queries/ringing';

export function IncomingLeadQueryModal({
  open,
  offer,
  secondsLeft,
  onAccept,
  onDecline,
}: {
  open: boolean;
  offer: IncomingLeadQueryOffer | null;
  secondsLeft: number;
  onAccept: () => void;
  onDecline: () => void;
}) {
  useEffect(() => {
    if (!open) stopRinging();
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onDecline()}>
      <DialogContent className="sm:max-w-[520px]">
        <DialogHeader>
          <DialogTitle>Incoming lead query</DialogTitle>
          <DialogDescription>
            The bot is requesting a human representative. Respond within{' '}
            <span className="font-medium">{Math.max(0, secondsLeft)}s</span>.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 text-sm">
          <div className="flex items-center gap-2">
            <Badge variant="outline">Query</Badge>
            <span className="font-mono">{offer?.queryId || '—'}</span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <p className="text-xs text-muted-foreground">Lead name</p>
              <p className="font-medium">{offer?.leadName || 'Website visitor'}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground">Phone</p>
              <p className="font-medium">{offer?.phone || '—'}</p>
            </div>
            <div className="sm:col-span-2">
              <p className="text-xs text-muted-foreground">Email</p>
              <p className="font-medium break-all">{offer?.email || 'Not shared yet'}</p>
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onDecline}>
            Decline
          </Button>
          <Button onClick={onAccept}>Accept</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

